import packageJson from '../../package.json'

/**
 * returns the current version set in package.json
 */
export const getCurrentVersion = (): string => {
	const version = packageJson?.version?.toString()
	return version ? version : ''
}